import { connect } from "../../utils/reduxUtils"
import Component from "./PendingMasavApps"
import * as ApplicationsSelector from "../../modules/applications/selectors"
import { Actions } from "../../pages/actions"

const mapDispatchToProps = {
    changeTab: Actions.ACTIVE_TAB_CHANGED,
    onMount: Actions.PENDING_MASAV_PAGE_MOUNTED,
    submitSearch: Actions.FILTER_SEARCH_APPLICATIONS_SUBMITTED,
    clearSearch: Actions.FILTER_SEARCH_APPLICATIONS_CLEARED,
    exportApplications: Actions.EXPORT_MASAV_SUBMITTED
};

const mapStateToProps = state => {
    return {
        loading: ApplicationsSelector.isLoading(state),
        data: ApplicationsSelector.applications(state),
        filter: ApplicationsSelector.filter(state),
        isSubmitting: ApplicationsSelector.isSubmitting(state),
        error: ApplicationsSelector.error(state)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Component);